// extracted by mini-css-extract-plugin
export var baseButton = "_oh-0";
export var controlsArrowKeys = "_oh-1";
export var controlsResetButton = "_oh-2";
export var lightGameButton = "_oh-4 _oh-0";
export var playAgainButton = "_oh-5 _oh-0";
export var startGameButton = "_oh-3 _oh-0";